module.exports = __webpack_public_path__ + "img/Bodice-Back-Ja-Kf-Ld.cd325c01.png";